// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"392":"0371911f","534":"f2fa0d9c"}[chunkId] + ".css";
};